module.exports = __webpack_public_path__ + "img/intro_tab3_2.b3a43b46.png";